// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Creditor } from './creditor';
import { CreditorClaimType } from './creditor-claim-type';
import { Dividend } from './dividend';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CreditorClass extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  creditorClassId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  description3!: string;
  displayOrder!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  creditorClaimTypes!: CreditorClaimType[];
  creditors!: Creditor[];
  dividends!: Dividend[];
}

